import type { InterviewInviteAttemptDtoStatus } from '@sara/api-client';
import { Badge, type BadgeProps } from '@sara/ui/components/badge';

type BadgeTone = NonNullable<BadgeProps['variant']>;

const META: Record<InterviewInviteAttemptDtoStatus, { label: string; tone: BadgeTone }> = {
  INITIATED: { label: 'Not connected', tone: 'neutral' },
  IN_PROGRESS: { label: 'In progress', tone: 'info' },
  FINISHED: { label: 'Finished', tone: 'success' },
  PAUSED: { label: 'Paused', tone: 'warning' },
  DISCONNECTED: { label: 'Disconnected', tone: 'warning' },
  PROCESSING: { label: 'Processing', tone: 'info' },
  DONE: { label: 'Completed', tone: 'success' },
  FAILED: { label: 'Failed', tone: 'danger' },
};

export function AttemptStatusBadge({ status }: { status: InterviewInviteAttemptDtoStatus }) {
  const { label, tone } = META[status];
  return <Badge variant={tone}>{label}</Badge>;
}
